import React, { Component } from 'react';
import ProjectsPage from './project-html';
class Projects extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <ProjectsPage
                />
            </div>
        )
    }
}
export default Projects;